import seoDefaultImageUrl from '../assets/images/table.jpg';

export default seoDefaultImageUrl;
